import { SectionWrapper } from "../SectionWrapper";
import React from "react";
import { Center, Text } from "@chakra-ui/react";

interface CompanyProfile {
  legalName: string;
  companyName: string;
  industry: string | null | undefined;
  industryDescription: string | null | undefined;
  website: string | null | undefined;
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  companyProfile: CompanyProfile;
}
export default function SectionCompanyProfile({ companyProfile, ...props }: Props) {
  console.log(companyProfile);
  return (
    <SectionWrapper title={companyProfile.companyName + " Company Profile"} {...props}>
      <Center>
        <Text textAlign={"center"}>Coming Soon.</Text>
      </Center>
    </SectionWrapper>
  );
}
